import { makeStyles } from '@material-ui/core/styles';

export const useEmptyStateStyles = makeStyles(() => ({
  imageEmptyState: {
    width: 195,
    height: 130,
    marginBottom: 40,
  },
  buttonEmptyState: {
    width: 200,
    height: 40,
  },
  titleEmptyState: {
    fontWeight: 600,
    marginBottom: 10,
  },
  subtitleEmptyState: {
    textAlign: 'center',
    marginBottom: 20,
  },
  emptyState: {
    border: '1px solid #D9D9D9',
    borderRadius: 10,
    paddingTop: 63,
    paddingBottom: 67,
  },
  infoMessage: {
    width: (props) => (props.mobile ? '95%' : '65%'),
  },
  goPurchases: {
    fontSize: 14,
    textDecoration: 'underline',
    color: '#1A1A1A',
    cursor: 'pointer',
    marginTop: 47,
  },
}));
